<template>
  <div id="download">
    <div class="poster">
      <img src="../../assets/images/poster/xiazzx.png" alt="">
    </div>
    
    <div class="container">
      <div class="btnContent">
        <div class="btnBox1" v-for="(item, index) in menuBtnList">
          <el-button
            type="text"
            :class="{ isShow: selectedBtn === index }"
            @click="queryProList(item, index)"
          >
            {{ item.name }}
          </el-button>
          <div v-if="index + 1 !== menuBtnList.length" style="width: 1px;margin: 0 10px;height: 15px; background: #000;"></div>
        </div>
      </div>
    </div>

    <div class="classTitle">
      <p class="title">{{ (menuBtnList.length > 0 && menuBtnList[selectedBtn].name) || ' ' }}</p>
    </div>

    <div class="display-list">
      <div class="display-item" v-for="item in dataList" @click="goDetail(item)">
        <!-- <div>
          <img :src="item.img" alt="">
        </div> -->
        <p class="fileItem">
          <mis-icon icon="Pdf" font-size="28px"></mis-icon>
          <span>{{ item.name }}</span>
        </p>
      </div>
    </div>

    <el-pagination
      v-show="total > 0"
      @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageNum"
      :page-size="10"
      layout="prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <p class="empty-class" v-if="dataList && dataList.length <= 0" :image-size="200">暂无数据 ～～～</p>
  </div>
</template>

<script>
import { proList } from "@/api/download";

export default {
  name: 'download',

  components: {
  },

  data () {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        type: ''
      },
      dataList: [],
      menuBtnList: [
        {
          name: '控制器与触摸屏类'
        },
        {
          name: '变送器与传感器类'
        },
        {
          name: '开关类'
        },
        {
          name: '阀门与驱动器类'
        },
        {
          name: '系统软件'
        }
      ],
      selectedBtn: 0,
      total: 0
    }
  },

  mounted () {
    this.$nextTick(function () {
      this.$store.state.el_.scrollTop = 0
    })
  },

  created() {
    this.queryProList(this.menuBtnList[0])
  },

  methods: {
    queryProList(item, index) {
      this.queryParams.type = item ? item.name : this.queryParams.type
      this.selectedBtn = index || index === 0 ? index : this.selectedBtn
      this.queryParams.pageNum = item ? 1 : this.queryParams.pageNum
      proList(this.queryParams).then(res => {
        console.log('产品列表', res)
        this.dataList = res.rows
        this.total = res.total
      })
    },

    goDetail(item) {
      this.$router.push({
        path: '/downloadDetail',
        query: {
          obj: JSON.stringify(item)
        }
      })
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.queryParams.pageNum = val
      this.queryProList()
    }
  }
}
</script>

<style lang='less' scoped>
@media screen and (max-width: 768px) {
  #download{
  }
}

@media screen and (min-width: 768px) {
  #download {
  }
}

#download {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .poster {
    width: 100%;

    img {
      width: 100%;
    }
  }

  ul {
    padding: 0;
  }
  .isShow {
    // background-color: red;
    color: red;
  }

  .empty-class {
    color: #e4e4e4;
  }
}

@media screen and (min-width: 768px) {
  .display-list {
    width: 1170px;
  }

  .classTitle {
    width: 1170px;
  }

  .display-item {
    div {
      width: 300px;
      height: 242px;
      overflow: hidden;
    }

    p {
      width: 300px;
    }
  }
}
@media screen and (max-width: 768px) {
  .display-list {
    width: 100%;
  }

  .classTitle {
    width: 100%;

    .title {
      font-size: 20px !important;
      line-height: 20px !important;
    }
  }

  .display-item {
    div {
      width: 170px;
      height: 140px;
      overflow: hidden;
    }
    p {
      width: 170px;
    }
  }
}

.container {
  width: 100%;

  .btnContent {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 5px;
    box-sizing: border-box;

    .btnBox1 {
      display: flex;
      align-items: center;

      .el-button {
        font-size: 18px;
      }
    }

    .btnBox2 {
      display: flex;
      align-items: center;

      .el-button {
        font-size: 15px;
      }
    }

    .el-button {
      padding: 10px 0;
      color: black;

      &:hover {
        color: red;
      }
    }
  }
}

.classTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #ececec;

  .title {
    font-size: 30px;
    font-weight: bold;
    line-height: 56px;
    color: #3b3b3b;
    letter-spacing: 2px;
    margin: 6px 0;
  }

  .content {
    font-size: 12px;
    color: #a0a0a0;
  }
}

.display-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 36px 5px;
  box-sizing: border-box;

  .display-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 6px 12px 6px;

    img {
      transition: all .5s;
      width: 100%;
      height: 100%;

      &:hover {
        transform: scale(1.2);
      }
    }

    p {
      margin: 0;
      padding: 5px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 15px;
      font-weight: bold;
      background-color: #fff;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    &:hover {
      cursor: pointer;

      p {
        background: #3a8ee6;
        color: #fff;
      }
    }
  }
}
</style>
